import { ADD_CREDIT, CHARGE, REFUND, REFUND_CREDIT } from "./index";
import locale from './locale'
import React from 'react'

export default function(paymentType) {

  let paymentOptions = []

  if (paymentType !== REFUND) {
    paymentOptions.push({
      label: __('Online Payment', locale), options: [
        { value: 'wechat_barcode_pay', label: __('WeChat Pay', locale) },
        { value: 'ali_barcode_pay', label: __('Alipay', locale) },
      ]
    });
  }

  paymentOptions.push({
    label: __('Transaction Record', locale),
    options: [
      { value: 'cash', label: __('Cash', 'PaymentModal') },
      { value: 'credit_card', label: __('Credit Card', 'PaymentModal') },
      { value: 'cheque', label: __('Cheque', 'PaymentModal') },
      { value: 'bank_transfer', label: __('Bank Transfer', 'PaymentModal') },
      { value: 'wechat_record_only', label: __('WeChat Pay Transfer', 'PaymentModal') },
      { value: 'ali_record_only', label: __('Alipay Transfer', 'PaymentModal') },
    ],
  });

  if (paymentType !== ADD_CREDIT) {
    paymentOptions.push({ value: 'school_credit', label: __('School Credit', 'PaymentModal') });
  }

  switch(paymentType) {
  case ADD_CREDIT:
    return defaultSchema.call(this, paymentOptions)
    break;
  case CHARGE:
    return chargeSchema.call(this, paymentOptions)
    break;
  case REFUND:
    return defaultSchema.call(this, paymentOptions)
    break;
  case REFUND_CREDIT:
    return defaultSchema.call(this, paymentOptions)
    break;
  }
}

function defaultSchema() {
	return [
    {
      name: 'send_email_or_not',
      placeholder: __('Send Receipt To Parents', locale),
      type: 'checkbox',
      required: false,
    },
    {
      name: 'email_recipient',
      label: __('Email', locale),
      type: 'email',
      required: this.state.formData.send_email_or_not ? true : false,
      hidden: this.state.formData.send_email_or_not ? false : true,
    },
    {
      name: 'paper_receipt_num',
      label: __('Paper Receipt Number', locale),
      type: 'text',
      required: false,
    },
    {
      name: 'remark',
      label: __('Remarks', locale),
      type: 'textarea',
      required: false,
    }
  ]
}

function chargeSchema(paymentOptions) {

  return [
    {
      name: 'trade_date',
      label: __('Charge Date', locale),
      type: 'datePicker',
      required: true,
    },
    {
      name: 'payment_method',
      label: __('Payment Methods', locale),
      type: 'reactSearch',
      required: true,
      options: paymentOptions,
      direction: 'up',
    },
    {
      name: 'send_email_or_not',
      placeholder: __('Send Receipt To Parents', locale),
      type: 'checkbox',
      required: false,
    },
    {
      name: 'email_recipient',
      label: __('Email', locale),
      type: 'email',
      required: this.state.formData.send_email_or_not ? true : false,
      hidden: this.state.formData.send_email_or_not ? false : true,
    },
    {
      name: 'paper_receipt_num',
      label: __('Paper Receipt Number', locale),
      type: 'text',
      required: false,
    },
    {
      name: 'remark',
      label: __('Remarks', locale),
      type: 'textarea',
      required: false,
    }
  ]
}



// WEBPACK FOOTER //
// ./src/template/Modals/NewPayment/schemaRight.js